import { render, staticRenderFns } from "./LegalAidApply.vue?vue&type=template&id=0018f58e&scoped=true&"
import script from "./LegalAidApply.vue?vue&type=script&lang=js&"
export * from "./LegalAidApply.vue?vue&type=script&lang=js&"
import style0 from "./LegalAidApply.vue?vue&type=style&index=0&id=0018f58e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0018f58e",
  null
  
)

export default component.exports